import { lazy } from 'react';

const KcLoginThemeApp = lazy(() => import('./login/KcApp'));

export const App = () => {
	if (window.kcContext?.themeType === 'login') {
		return <KcLoginThemeApp kcContext={window.kcContext} />;
	}

	throw new Error(
		'This app is a Keycloak theme' + "It isn't meant to be deployed outside of Keycloak",
	);
};

declare global {
	interface Window {
		kcContext?: import('./login/KcContext.ts').KcContext;
	}
}
